<script setup lang="ts">
import { ref } from 'vue'
import { cn } from '@/lib/cn'
import { FIELD_CLASSES } from './variants'

defineOptions({ inheritAttrs: false })
defineProps<{ modelValue?: string | number | null }>()
const emit = defineEmits<{ 'update:modelValue': [v: string] }>()
const el = ref<HTMLInputElement | null>(null)
/** `autofocus` only works on the first page load: screens that remount focus through this. */
defineExpose({ focus: () => el.value?.focus(), el })
</script>

<template>
  <input ref="el" v-bind="$attrs" :class="cn(FIELD_CLASSES, 'h-9 py-1.5', $attrs.class as string)" :value="modelValue ?? ''"
         @input="emit('update:modelValue', ($event.target as HTMLInputElement).value)" />
</template>
